import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { EnvironmentConfiguration } from './environment/services/environment.configuration';
import { BpgCommonService } from './bpg-common/services/bpg-common.service';
import { environment } from 'src/environments/environment';
import { environment_Local } from 'src/environments/environment.local'
import { environment_QA } from 'src/environments/environment.qa'
import { environment_PROD } from 'src/environments/environment.prod'

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private bpgCommonService: BpgCommonService, private router: Router, private environment: EnvironmentConfiguration) { }


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<any> | Promise<any> | boolean {
    //  console.log("ADAL :" + this.environment.loginADAL);
    //  console.log("ADAL USER INFO "+JSON.stringify(this.adalService.userInfo));

    //Check to run application locally or in staging/production using ADAL Authentication 
    
    const codefromurl = sessionStorage.getItem('codeResponse');

    const token = sessionStorage.getItem('id_token');

    const refresh_token = sessionStorage.getItem('refresh_token');

    const access_token = sessionStorage.getItem('access_token');

    if (codefromurl != null && token != null && refresh_token != null && access_token != null &&

      codefromurl != undefined && token != undefined && refresh_token != undefined && access_token != undefined) {
      //if (localStorage.getItem('userEmail')) {
        //let originUrl = window.location.origin
       // if (originUrl.includes('event-view-details'))
         // this.router.navigate(['/event-view-details']);
       // else
        //  this.router.navigate(['/di-home']);
     // }
      return true

    }
    else {

      if (codefromurl != null && sessionStorage.getItem('id_token') == null) {
        return this.bpgCommonService.userLogin();
      }

      else {
        let baseLoginUrl;
        if (this.environment.envName == 'default' || this.environment.envName == 'local' || this.environment.envName == 'staging') {
          baseLoginUrl = environment_Local.baseLoginUrl
        } else if (this.environment.envName == 'qa') {
          baseLoginUrl = environment_QA.baseLoginUrl
        }
        else if (this.environment.envName == 'prod') {
          baseLoginUrl = environment_PROD.baseLoginUrl
        }
        localStorage.setItem("redirectURl",window.location.href);
        const redirectUrl = baseLoginUrl + environment.codeChallenge;
        window.location.href = redirectUrl;
        return true;
      }
    }
  }

  // canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
  //   return true;
  // }

  //get authenticated(): boolean {
  //console.log("this.adalService.userInfo.authenticated : " + this.adalService.userInfo.authenticated);
  //return this.adalService.userInfo.authenticated;
  //}



}
